import { UserMessageTopic } from '@viewbid/ts-angular-client';
import { VbSupportSubject } from '@viewbid/ui';

/** Per-topic copy from the support-messaging design handoff: the subject
 *  row's second line and the compose-step heading, keyed by API topic key. */
const SUBJECT_COPY: Record<string, { subtitle: string; composeTitle: string }> =
    {
        ISSUE_WITH_ORDER: {
            subtitle: 'Payment, pickup or invoice',
            composeTitle: "Which order, and what's wrong?",
        },
        PROBLEM_WITH_WEBSITE: {
            subtitle: "Something isn't working",
            composeTitle: 'What were you trying to do?',
        },
        GENERAL_ENQUIRY: {
            subtitle: 'Anything else',
            composeTitle: 'What can we help with?',
        },
    };

/** Topics that never render as subject rows: the lot topic is driven by the
 *  widget's [lot] input (lot pages open straight into compose), and the call
 *  option is the widget's own built-in row (shown when [phone] is set). */
const NON_ROW_TOPICS: string[] = ['ASK_ABOUT_LOT', 'GIVE_US_A_CALL'];

/** Maps the user-message topics API onto vb-support-widget subject rows.
 *  Labels stay server truth; sub/compose copy comes from the handoff, with a
 *  generic compose heading for any key added after this was written. */
export function mapTopicsToSupportSubjects(
    topics: UserMessageTopic[],
): VbSupportSubject[] {
    return topics
        .filter(
            (topic: UserMessageTopic) => !NON_ROW_TOPICS.includes(topic.key),
        )
        .map((topic: UserMessageTopic) => ({
            key: topic.key,
            title: topic.label,
            subtitle: SUBJECT_COPY[topic.key]?.subtitle,
            composeTitle:
                SUBJECT_COPY[topic.key]?.composeTitle ??
                'What can we help with?',
        }));
}

/** Fallback rows when the topics fetch fails — the same set the server ships
 *  today (keys are enum-fixed in the API client), so the panel stays usable. */
export const FALLBACK_SUPPORT_SUBJECTS: VbSupportSubject[] = [
    {
        key: 'ISSUE_WITH_ORDER',
        title: 'Issue with an order',
        ...SUBJECT_COPY['ISSUE_WITH_ORDER'],
    },
    {
        key: 'PROBLEM_WITH_WEBSITE',
        title: 'Problem with the website',
        ...SUBJECT_COPY['PROBLEM_WITH_WEBSITE'],
    },
    {
        key: 'GENERAL_ENQUIRY',
        title: 'General inquiry',
        ...SUBJECT_COPY['GENERAL_ENQUIRY'],
    },
];
